import { AppSettings } from "../configs";
import { authHeader } from "../helpers/auth-header";
import axios from "../utils/axios";

const UserServices = {};

UserServices.loginFromADToken = (tokenType, accessToken) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: { ...authHeader(), Pragma: "no-cache" },
      method: "post",
      url: `${AppSettings.apiUrl}/api/User/AuthenticateByADToken`,
      data: { tokenType: tokenType , accessToken: accessToken},
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

UserServices.ADConfig = () => {
  return new Promise((resolve, reject) => {
    axios({
      headers: { ...authHeader(), Pragma: "no-cache" },
      method: "get",
      url: `${AppSettings.apiUrl}/api/User/ADConfig`,
      data: {},
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

UserServices.info = () => {
  return new Promise((resolve, reject) => {
    axios({
      headers: { ...authHeader(), Pragma: "no-cache" },
      method: "post",
      url: `${AppSettings.apiUrl}/api/User/Info`,
      data: {},
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};


UserServices.ApplicationReadonly = () => {
  return new Promise((resolve, reject) => {
    axios({
      headers: { ...authHeader(), Pragma: "no-cache" },
      method: "post",
      url: `${AppSettings.apiUrl}/api/User/ApplicationReadonly`,
      data: {},
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};


export default UserServices;
